import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Store} from '@ngrx/store';
import { Subscription } from 'rxjs/internal/Subscription';
import {OAuthService} from 'angular-oauth2-oidc';
import { MatDialog } from '@angular/material/dialog';

import {FuseConfigService} from '@fuse/services/config.service';
import {FuseTranslationLoaderService} from '@fuse/services/translation-loader.service';
import {fuseAnimations} from '@fuse/animations';
import {authLoginUsernamePassword} from '@aes/core/auth/auth.actions';
import {LocalStorageService} from '@aes/core/local-storage/local-storage.service';
import {selectErrLogin} from '@aes/core/auth/auth.selectors';

import {locale as english} from './i18n/en';
import {locale as vietnam} from './i18n/vn';
import { ContactITDialogComponent } from './contact-it-dialog/contact-it-dialog.component';
import {skip} from 'rxjs/operators';

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class LoginComponent implements OnInit, OnDestroy {
    errLoginSubscriber: Subscription;
    loginForm: FormGroup;
    enableGoogleLogin = false;
    errLogin = null;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     * @param _store
     * @param _fuseTranslationLoaderService
     * @param _oauthService
     * @param _storageService
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        private _store: Store<any>,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _oauthService: OAuthService,
        private _matDialog: MatDialog,
        private _storageService: LocalStorageService,
    ) {
        // Initialize oauthService
        this._oauthService.loadDiscoveryDocument();

        this._fuseTranslationLoaderService.loadTranslations(english, vietnam);
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer: {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.loginForm = this._formBuilder.group({
            username: ['', [Validators.required]],
            password: ['', Validators.required]
        });

        // subscribe to login error object
        this.errLoginSubscriber = this._store.select(selectErrLogin).pipe(skip(1)).subscribe(err => this.errLogin = err);
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        this.errLoginSubscriber.unsubscribe();
    }

    onLoginClick(): void {
        this._store.dispatch(authLoginUsernamePassword({
            username: this.loginForm.get('username').value,
            password: this.loginForm.get('password').value
        }));
    }

    openDialog(): void {
        this._matDialog.open(ContactITDialogComponent);
    }
}
